import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomToasterServiceService {

  private _successMessage: BehaviorSubject<string> = new BehaviorSubject<string>('')
  private _processMessage: BehaviorSubject<string> = new BehaviorSubject<string>('')
  private _errorMessage: BehaviorSubject<string> = new BehaviorSubject<string>('')

  constructor() {}

  success(msg: string) {
    this._successMessage.next(msg)
    this._processMessage.next('') 
    setTimeout(() => {
      this._successMessage.next('')
    }, 5000)
  }

  showSuccess(msg: string) {
    this._successMessage.next(msg)
    this._processMessage.next('') 
  }

  error(msg: string) {
    this._errorMessage.next(msg)
    setTimeout(() => {
      this._errorMessage.next('')
    }, 5000)
  }

  process(msg: string) {
    this._processMessage.next(msg)
  }

  get successMessage$() {
    return this._successMessage.asObservable()
  }

  get errorMessage$() {
    return this._errorMessage.asObservable()
  }

  get processMessage$() {
    return this._processMessage.asObservable()
  }
}
